<template>
  <div class="configuracion-usuario">
    <div class="config-wrapper">
      <ModalLoading :isLoading="isLoading" />

      <div class="company-config">
        <form
          @submit.prevent="guardarConfiguracionSAR"
          autocomplete="off"
          class="formulario form-company-SAR"
        >
          <fieldset :disabled="busisnessSarEditing">
            <div class="contenedor-titulo">
              <h2 class="titulo-form">Configuración SAR</h2>
            </div>

            <div class="contenedor-principal">
              <div class="contenedor-interno contenedor-izquierdo">
                <label for="numero_CAI">Numero CAI:</label>
                <input
                  v-model="configuracionSAR.numero_CAI"
                  type="text"
                  id="numero_CAI"
                  maxlength="45"
                  required
                />

                <label for="rango_inicial">Rango Inicial:</label>
                <input
                  v-model="configuracionSAR.rango_inicial"
                  type="text"
                  id="rango_inicial"
                  required
                />

                <label for="rango_final">Rango Final:</label>
                <input
                  v-model="configuracionSAR.rango_final"
                  type="text"
                  id="rango_final"
                  required
                />
              </div>
              <div class="contenedor-interno contenedor-derecho">
                <label for="fecha_autorizacion">Fecha de autorización:</label>
                <input
                  v-model="configuracionSAR.fecha_autorizacion"
                  type="date"
                  id="fecha_autorizacion"
                  required
                  :max="today"
                  @keypress="soloNumeros($event)"
                />

                <label for="fecha_vencimiento">Fecha de vencimiento:</label>
                <input
                  v-model="configuracionSAR.fecha_vencimiento"
                  type="date"
                  id="fecha_vencimiento"
                  required
                  @keypress="soloNumeros($event)"
                />
              </div>
            </div>
          </fieldset>

          <div class="botones-container">
            <!-- ✅ NUEVO BOTÓN DE DESCARGA -->
            <button
              class="btn descargar"
              @click.prevent="descargarHistorialPDF"
              type="button"
            >
              📄 Descargar Historial
            </button>

            <button
              class="btn editar"
              @click="isEditing(4)"
              :disabled="!busisnessSarEditing"
              type="button"
            >
              Editar
            </button>
            <button
              class="btn guardar"
              type="submit"
              :disabled="busisnessSarEditing"
              @click.prevent="updateSAR"
            >
              Guardar
            </button>
          </div>
        </form>
      </div>
    </div>

    <router-link to="/config-page">
      <button class="btn boton-switch inactivo">Config. Usuario</button>
    </router-link>

    <button class="btn boton-switch activo">Config SAR</button>
  </div>
</template>

<script>
import axios from "axios";
const { getApi } = require("../../config/getApiUrl.js");
import { setPageTitle } from "@/components/pageMetadata";
// ✅ BIEN
import { validacionesConfigSAR } from "../../services/validarCampos.js";
import { notis } from "../../services/notificaciones.js";
import ModalLoading from "@/components/ModalLoading.vue";

export default {
  components: {
    ModalLoading,
  },
  data() {
    return {
      titulo: "Configuración SAR",
      isLoading: false,
      busisnessSarEditing: true,
      esCeo: false,
      today: new Date().toISOString().split('T')[0],
      configuracionSAR: {
        numero_CAI: "",
        rango_inicial: "",
        rango_final: "",
        fecha_autorizacion: "",
        fecha_vencimiento: "",
      },
    };
  },

  methods: {
    soloNumeros(event) {
      const codigoTecla = event.keyCode || event.which;
      const tecla = String.fromCharCode(codigoTecla);
      const regex = /^[0-9.]$/;
      if (
        !regex.test(tecla) ||
        (tecla === "." && event.target.value.includes("."))
      ) {
        event.preventDefault();
        return false;
      }
    },

    validateSARNumber(number) {
      return /^\d{16}$/.test(number);
    },

    async getConfiguracionSAR() {
      try {
        const token = localStorage.getItem("auth");
        const response = await axios.get(`${getApi()}/sar`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        const sarData = response.data.datosSAR;

        this.configuracionSAR.numero_CAI = sarData.numero_CAI || "";
        this.configuracionSAR.rango_inicial = sarData.rango_inicial || "";
        this.configuracionSAR.rango_final = sarData.rango_final || "";
        this.configuracionSAR.fecha_autorizacion =
          sarData.fecha_autorizacion || "";
        this.configuracionSAR.fecha_vencimiento =
          sarData.fecha_vencimiento || "";
      } catch (error) {
        console.error("Error al obtener la configuración SAR:", error);
        notis("error", "No se pudo obtener la configuración SAR.");
      }
    },

    async updateSAR() {
      // Usar las validaciones definidas
      if (
        !validacionesConfigSAR.validarCamposConfiguracion(this.configuracionSAR)
      ) {
        return;
      }

      this.isLoading = true;
      try {
        const token = localStorage.getItem("auth");

        // Los rangos ya deberían estar formateados por las validaciones
        const updatedData = {
          numero_CAI: this.configuracionSAR.numero_CAI,
          rango_inicial: this.configuracionSAR.rango_inicial,
          rango_final: this.configuracionSAR.rango_final,
          fecha_autorizacion: this.configuracionSAR.fecha_autorizacion,
          fecha_vencimiento: this.configuracionSAR.fecha_vencimiento,
          numero_actual_SAR: this.configuracionSAR.rango_inicial, // Se inicializa con el rango inicial
        };

        const response = await axios.post(
          `${getApi()}/sar/create`,
          updatedData,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        );

        if (
          response?.data?.success ||
          response?.data?.id ||
          response?.status < 300
        ) {
          // Esperar a que se muestre la notificación antes de recargar
          await new Promise((resolve) => {
            notis("success", "Datos SAR actualizados exitosamente");
            // Dar tiempo para que la notificación sea visible
            setTimeout(resolve, 1500);
          });

          window.location.reload();
        }
      } catch (error) {
        console.error("Error al actualizar los datos SAR:", error);
        if (error.response) {
          notis("error", "Hubo un problema al guardar los datos.");
        } else if (error.request) {
          notis("error", "Error de conexión con el servidor.", {});
        } else {
          notis("error", "Hubo un problema al guardar los datos.", {});
        }
      } finally {
        this.isLoading = false;
      }
    },

   // ✅ NUEVO MÉTODO: Descargar historial en PDF
async descargarHistorialPDF() {
  this.isLoading = true;
  try {
    const token = localStorage.getItem("auth");
    
    // Obtener historial de SAR
    const response = await axios.get(`${getApi()}/sar/historial`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    if (!response.data.success || !response.data.historial) {
      notis("warning", "No hay historial de SAR para esta sucursal");
      return;
    }

    const historial = response.data.historial;
    const sucursal = response.data.sucursal; // ✅ Ahora viene del backend

    // Generar PDF
    await this.generarPDFHistorial(historial, sucursal);

  } catch (error) {
    console.error("Error al descargar historial:", error);
    if (error.response?.status === 404) {
      notis("info", "No hay registros de SAR para mostrar");
    } else {
      notis("error", "Error al generar el historial PDF");
    }
  } finally {
    this.isLoading = false;
  }
},

    // ✅ NUEVO MÉTODO: Generar PDF con historial
    async generarPDFHistorial(historial, sucursal) {
      const jsPDF = (await import('jspdf')).default;
      await import('jspdf-autotable');

      const doc = new jsPDF({
        orientation: 'landscape',
        unit: 'mm',
        format: 'letter'
      });

      // Logo (si existe)
      const logoEmpresa = localStorage.getItem("logoEmpresa");
      if (logoEmpresa) {
        try {
          doc.addImage(logoEmpresa, 'JPEG', 15, 10, 30, 20);
        } catch (_e) {
          // logo no disponible, continúa sin él
        }
      }

      // Encabezado
      doc.setFontSize(16);
      doc.setFont(undefined, 'bold');
      doc.text(sucursal.nombre_administrativo || 'Sucursal', logoEmpresa ? 50 : 15, 20);
      
      doc.setFontSize(10);
      doc.setFont(undefined, 'normal');
      if (sucursal.direccion) {
        doc.text(sucursal.direccion, logoEmpresa ? 50 : 15, 25);
      }
      if (sucursal.telefono) {
        doc.text(`Tel: ${sucursal.telefono}`, logoEmpresa ? 50 : 15, 30);
      }

      // Título del reporte
      doc.setFontSize(14);
      doc.setFont(undefined, 'bold');
      doc.text('HISTORIAL DE CONFIGURACIONES SAR', 15, 45);
      
      doc.setFontSize(10);
      doc.setFont(undefined, 'normal');
      doc.text(`Generado: ${new Date().toLocaleDateString('es-HN')}`, 15, 50);

      // Función auxiliar para formatear fechas
      const formatearFecha = (fecha) => {
        return new Date(fecha).toLocaleDateString('es-HN');
      };

      // Función auxiliar para formatear rangos
      const formatearRango = (rango) => {
        if (!rango || rango.length !== 16) return rango;
        return `${rango.slice(0, 3)}-${rango.slice(3, 6)}-${rango.slice(6, 8)}-${rango.slice(8)}`;
      };

      // Preparar datos para la tabla
      const tableData = historial.map((sar, index) => {
        return [
          index + 1,
          sar.numero_CAI,
          formatearRango(sar.rango_inicial),
          formatearRango(sar.rango_final),
          formatearRango(sar.numero_actual_SAR),
          formatearFecha(sar.fecha_autorizacion),
          formatearFecha(sar.fecha_vencimiento),
          `${sar.facturas_usadas} / ${sar.total_facturas}`,
          `${sar.porcentaje_usado}%`,
          sar.estado_texto
        ];
      });

      // Crear tabla
      doc.autoTable({
        head: [[
          '#',
          'CAI',
          'Rango Inicial',
          'Rango Final',
          'Actual',
          'F. Autorización',
          'F. Vencimiento',
          'Facturas Usadas',
          '% Usado',
          'Estado'
        ]],
        body: tableData,
        startY: 60,
        styles: {
          fontSize: 7,
          cellPadding: 2,
          overflow: 'linebreak',
          lineColor: [200, 200, 200],
          lineWidth: 0.1
        },
        headStyles: {
          fillColor: [0, 0, 0],
          textColor: 255,
          fontStyle: 'bold',
          fontSize: 7,
          halign: 'center'
        },
        columnStyles: {
          0: { halign: 'center', cellWidth: 8 },
          1: { halign: 'left', cellWidth: 35 },
          2: { halign: 'center', cellWidth: 30 },
          3: { halign: 'center', cellWidth: 30 },
          4: { halign: 'center', cellWidth: 30 },
          5: { halign: 'center', cellWidth: 22 },
          6: { halign: 'center', cellWidth: 22 },
          7: { halign: 'center', cellWidth: 25 },
          8: { halign: 'center', cellWidth: 15 },
          9: { halign: 'center', cellWidth: 18 }
        },
        alternateRowStyles: {
          fillColor: [245, 245, 245]
        },
        didDrawCell: (data) => {
          // Colorear la columna de estado
          if (data.column.index === 9 && data.section === 'body') {
            const estado = data.cell.raw;
            let color;
            
            switch(estado) {
              case 'ACTIVO':
                color = [40, 167, 69]; // Verde
                break;
              case 'VENCIDO':
                color = [220, 53, 69]; // Rojo
                break;
              case 'AGOTADO':
                color = [255, 193, 7]; // Amarillo oscuro
                break;
              default:
                color = [108, 117, 125]; // Gris
            }
            
            doc.setFillColor(...color);
            doc.rect(data.cell.x, data.cell.y, data.cell.width, data.cell.height, 'F');
            doc.setTextColor(255, 255, 255);
            doc.setFontSize(7);
            doc.text(estado, data.cell.x + data.cell.width / 2, data.cell.y + data.cell.height / 2, {
              align: 'center',
              baseline: 'middle'
            });
          }
        }
      });

      // Resumen al final
      const finalY = doc.lastAutoTable.finalY + 10;
      
      doc.setFontSize(10);
      doc.setFont(undefined, 'bold');
      doc.text('RESUMEN:', 15, finalY);
      
      doc.setFont(undefined, 'normal');
      doc.text(`Total de registros SAR: ${historial.length}`, 15, finalY + 5);
      
      const activos = historial.filter(s => s.estado_texto === 'ACTIVO').length;
      const vencidos = historial.filter(s => s.estado_texto === 'VENCIDO').length;
      const agotados = historial.filter(s => s.estado_texto === 'AGOTADO').length;
      const inactivos = historial.filter(s => s.estado_texto === 'INACTIVO').length;
      
      doc.text(`SAR Activos: ${activos}`, 15, finalY + 10);
      doc.text(`SAR Vencidos: ${vencidos}`, 60, finalY + 10);
      doc.text(`SAR Agotados: ${agotados}`, 105, finalY + 10);
      doc.text(`SAR Inactivos: ${inactivos}`, 150, finalY + 10);

      // Guardar PDF
      const fechaArchivo = new Date().toISOString().split('T')[0];
      const nombreSucursal = (sucursal.nombre_administrativo || 'Sucursal').replace(/\s+/g, '_');
      doc.save(`Historial_SAR_${nombreSucursal}_${fechaArchivo}.pdf`);

      notis("success", "PDF generado exitosamente");
    },

    pushEsc(event) {
      if (event.key === "Esc" || event.key === "Escape") {
        this.usuarioEditing = true;
        this.busisnessSarEditing = true;
        this.businessEditing = true;
        this.usuarioAvancedEditing = true;
      }
    },

    isEditing(orden) {
      switch (orden) {
        case 1:
          this.usuarioEditing = false;
          this.busisnessSarEditing = true;
          this.businessEditing = true;
          this.usuarioAvancedEditing = true;
          break;
        case 2:
          this.usuarioEditing = true;
          this.busisnessSarEditing = true;
          this.businessEditing = true;
          this.usuarioAvancedEditing = false;
          break;
        case 3:
          this.usuarioEditing = true;
          this.busisnessSarEditing = true;
          this.businessEditing = false;
          this.usuarioAvancedEditing = true;
          break;
        case 4:
          this.usuarioEditing = true;
          this.busisnessSarEditing = false;
          this.businessEditing = true;
          this.usuarioAvancedEditing = true;
          break;
        default:
          notis("error", "Ha ocurrido un error", {
            timeout: 5000,
          });
      }
    },

    changeFavicon(iconPath) {
      const link =
        document.querySelector("link[rel*='icon']") ||
        document.createElement("link");
      link.type = "image/x-icon";
      link.rel = "icon";
      link.href = iconPath;
      document.getElementsByTagName("head")[0].appendChild(link);
    },
  },

  mounted() {
    this.getConfiguracionSAR();
    window.addEventListener("keydown", this.pushEsc);
    setPageTitle("Configuración SAR");
  },

  beforeUnmount() {
    window.removeEventListener("keydown", this.pushEsc);
  },
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Montserrat:wght@400;600&display=swap");

* {
  box-sizing: border-box;
  font-family: "Montserrat", sans-serif;
}

/* Configuración del usuario */
.configuracion-usuario {
  padding: 16px;
}

/* Contenedores principales */
.config-wrapper {
  padding: 16px;
  width: 100%;
  overflow-x: hidden;
}

.contenedor-principal {
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
  gap: 20px;
}

.contenedor-interno {
  display: flex;
  flex-direction: column;
  width: 50%;
  padding: 0 2%;
}

.formulario {
  margin-bottom: 5%;
}

fieldset {
  margin: 0;
  padding: 0;
  border: none;
}

fieldset:disabled label,
fieldset:disabled input {
  color: #858585;
}

.contenedor-principal input {
  margin-bottom: 4%;
}

/* Botones */
.botones-container {
  display: flex;
  justify-content: end;
  margin-right: 2.5%;
  flex-wrap: wrap;
  gap: 10px;
}

.botones-container .btn {
  border-radius: 5px;
}

.botones-container .btn:disabled {
  background-color: #888787;
}

/* Estilos base para los botones de navegación */
.btn {
  padding: 8px 16px;
  margin: 4px;
  border: none;
  cursor: pointer;
}

.boton-switch {
  padding: 10px 18px;
  transition: all 0.3s ease;
}

/* Estilos para el botón activo */
.activo {
  background-color: #c09d62;
  color: #ffffff;
  border: 1px solid #a38655;
  transition: all 0.3s ease;
}

.activo:hover {
  background-color: #a38655;
}

.inactivo {
  background-color: #f5f5f5;
  color: #666666;
  border: 1px solid #e0e0e0;
  transition: all 0.3s ease;
}

.inactivo:hover {
  background-color: #e8e8e8;
}

/* Modo oscuro */
.dark .activo {
  background-color: #c09d62;
  color: #ffffff;
  border: 1px solid #a38655;
}

.dark .activo:hover {
  background-color: #a38655;
}

.dark .inactivo {
  background-color: #2d2d2d;
  color: #909090;
  border: 1px solid #404040;
}

.dark .inactivo:hover {
  background-color: #363636;
}

/* Scroll personalizado */
.config-wrapper::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

.config-wrapper::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}

.config-wrapper::-webkit-scrollbar-thumb {
  background: #c09d62;
  border-radius: 4px;
}

.config-wrapper::-webkit-scrollbar-thumb:hover {
  background: #a38655;
}

/* Large Desktop (1440px y más) */
@media screen and (min-width: 1440px) {
  .company-config {
    max-width: 1200px;
  }

  .contenedor-interno {
    padding: 0 4%;
  }

  input {
    font-size: 1rem;
    padding: 12px 16px;
  }

  .titulo-form {
    font-size: 1.8rem;
  }
}

/* Desktop (1200px a 1439px) */
@media screen and (max-width: 1200px) {
  .company-config {
    width: 95%;
  }

  .contenedor-interno {
    padding: 0 3%;
  }
}

/* Tablet Landscape (992px a 1199px) */
@media screen and (max-width: 992px) {
  .company-config {
    width: 100%;
    padding: 15px;
  }

  .contenedor-principal {
    flex-direction: column;
    gap: 0;
  }

  .contenedor-interno {
    width: 100%;
    padding: 0 20px;
  }

  form {
    padding: 20px 15px;
  }

  .titulo-form {
    font-size: 1.4rem;
    margin-bottom: 30px;
  }

  input[type="date"] {
    width: 100%;
  }
}

/* Tablet Portrait (768px a 991px) */
@media screen and (max-width: 768px) {
  .configuracion-usuario,
  .config-wrapper {
    padding: 12px;
  }

  .company-config {
    padding: 10px;
  }

  .contenedor-interno {
    padding: 0 15px;
  }

  input {
    width: 100%;
    margin-bottom: 15px;
    font-size: 0.9rem;
  }

  label {
    font-size: 0.9rem;
    margin-bottom: 6px;
  }

  .botones-container {
    justify-content: center;
    padding: 0 15px;
    margin-top: 20px;
    gap: 15px;
  }

  .boton-switch {
    padding: 10px 15px;
    min-width: 150px;
  }

  .btn {
    padding: 10px 20px;
  }
}

/* Mobile (576px a 767px) */
@media screen and (max-width: 576px) {
  .configuracion-usuario,
  .config-wrapper {
    padding: 10px;
  }

  .company-config {
    width: 100%;
    padding: 5px;
  }

  form {
    padding: 15px 10px;
    margin-bottom: 20px;
  }

  .contenedor-interno {
    padding: 0 10px;
  }

  .titulo-form {
    font-size: 1.2rem;
    margin-bottom: 20px;
  }

  .botones-container {
    flex-direction: column;
    padding: 0 10px;
  }

  .btn,
  .boton-switch {
    width: 100%;
    margin: 5px 0;
    font-size: 0.95rem;
  }

  input[type="date"] {
    padding-right: 8px;
  }
}

/* Small Mobile (400px y menos) */
@media screen and (max-width: 400px) {
  .configuracion-usuario,
  .config-wrapper {
    padding: 5px;
  }

  .company-config {
    padding: 5px;
  }

  form {
    padding: 12px 8px;
    border-radius: 8px;
  }

  .contenedor-interno {
    padding: 0 8px;
  }

  .titulo-form {
    font-size: 1.1rem;
    margin-bottom: 15px;
  }

  input {
    padding: 6px 10px;
    font-size: 0.875rem;
    margin-bottom: 12px;
  }

  input[type="date"] {
    font-size: 0.875rem;
  }

  label {
    font-size: 0.875rem;
    margin-bottom: 4px;
  }

  .btn {
    padding: 8px 16px;
    font-size: 0.875rem;
  }

  .botones-container {
    gap: 8px;
    margin-top: 15px;
  }
}

/* Contenedor principal */
.dark .configuracion-usuario {
  background-color: #1e1e1e;
  color: #fff;
}

.dark .config-wrapper {
  background-color: #1e1e1e;
  color: #fff;
}

/* Formularios */
.dark form {
  border-color: #404040;
  background-color: #2d2d2d;
}

.dark input:focus {
  border-color: #c09d62;
}

/* Campos deshabilitados */
.dark fieldset:disabled label,
.dark fieldset:disabled input {
  color: #666;
  background-color: #2d2d2d;
}

/* Scroll personalizado en modo oscuro */
.dark .config-wrapper::-webkit-scrollbar-track {
  background: #2d2d2d;
}

.dark .config-wrapper::-webkit-scrollbar-thumb {
  background: #c09d62;
}

.dark .config-wrapper::-webkit-scrollbar-thumb:hover {
  background: #a38655;
}

/* Otros elementos en modo oscuro */
.dark label {
  color: #fff;
}

.dark ::-webkit-input-placeholder {
  color: #666;
}

.dark :-ms-input-placeholder {
  color: #666;
}

.dark ::placeholder {
  color: #666;
}

/* Input autofill en modo oscuro */
.dark input:-webkit-autofill,
.dark input:-webkit-autofill:hover,
.dark input:-webkit-autofill:focus {
  -webkit-text-fill-color: #fff;
  -webkit-box-shadow: 0 0 0px 1000px #383838 inset;
  transition: background-color 5000s ease-in-out 0s;
}

/* Form Groups y Contenedores */
.contenedor-titulo {
  margin: 0;
  padding: 0;
  width: 100%;
  display: flex;
  justify-content: center;
  padding: 0 24px;
  margin-bottom: 45px;
}

.company-config {
  max-width: 1000px;
  width: 90%;
  margin: 0 auto;
  padding: 20px;
}

form {
  border: 1px solid rgb(110, 109, 109);
  padding: 24px 0;
  border-radius: 10px;
  min-width: 300px;
  width: 100%;
  min-height: 200px;
  position: relative;
}

/* Título del form */
.titulo-form {
  position: relative;
  color: #333333;
  font-weight: 600;
  font-size: 1.5rem;
  margin: 0;
  padding: 0;
  border-bottom: 2px solid #c09d62;
}

/* Inputs y Labels */
input {
  padding: 10px 12px;
  height: 35px;
  margin-bottom: 16px;
  border: 1px solid #ddd;
  border-radius: 4px;
  width: 95%;
  background-color: #f8f9fa;
  transition: all 0.3s ease;
}

label {
  margin-bottom: 8px;
  font-weight: 500;
}

/* ✅ Botón de descarga */
.descargar {
  background-color: #007bff;
  font-weight: bolder;
  color: white;
  transition: all 0.3s ease;
}

.descargar:hover {
  background-color: #0056b3;
  transform: scale(1.02);
}

/* Estilos para los botones */
.editar {
  background-color: #c09d62;
  font-weight: bolder;
  color: white;
}

.editar:hover {
  background-color: #a38655;
  transform: scale(1.02);
  transition: all 0.3s ease;
}

.editar:disabled {
  background-color: #c09d62 !important;
  opacity: 0.7;
  cursor: not-allowed;
}

.guardar {
  background-color: #009b15;
  font-weight: bolder;
  color: white;
  transition: all 0.3s ease;
}

.guardar:hover:not(:disabled) {
  background-color: #008512;
  transform: scale(1.02);
}

.guardar:disabled {
  background-color: #e0e0e0;
  color: #909090;
  cursor: not-allowed;
  transform: none;
}

/* Modo Oscuro */
.dark .descargar {
  background-color: #0066cc;
  color: white;
}

.dark .descargar:hover {
  background-color: #004c99;
}

.dark .editar {
  background-color: #c09d62;
  color: white;
}

.dark .editar:hover {
  background-color: #a38655;
}

.dark .editar:disabled {
  background-color: #c09d62 !important;
  opacity: 0.7;
}

.dark .guardar {
  background-color: #009b15;
  color: white;
}

.dark .guardar:hover:not(:disabled) {
  background-color: #008512;
}

.dark .guardar:disabled {
  background-color: #2d2d2d;
  color: #666;
  border: 1px solid #404040;
}

.dark input {
  background-color: #383838;
  border-color: #404040;
  color: #fff;
}

.dark .titulo-form {
  background-color: #1e1e1e;
  color: #fff;
}

/* Focus states */
input:focus {
  outline: none;
  border-color: #c09d62;
  box-shadow: 0 0 0 3px rgba(192, 157, 98, 0.2);
  transition: all 0.3s ease;
}
</style>
